import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import type { RouteMeta } from "./routes";
import { getToken } from "@/lib/auth";

export function AuthGuard({
  meta,
  children,
}: {
  meta: RouteMeta;
  children: ReactNode;
}) {
  const token = getToken();
  const location = useLocation();
  const needAuth = meta.requiresAuth && !token;

  if (needAuth) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
